import React, { useState } from 'react';
import Button from 'components/UI/Button';
import { connect } from 'react-redux';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import Row from 'components/UI/Layout/Row';
import { saveMemberPhone, updateMemberPhone } from 'store/dispatchers/members.dispatchers';
import PropTypes from 'prop-types';
import EditableTextInput from 'components/UI/Input/EditableTextInput';
import FormComponent from 'components/UI/Input/FormComponent';
import { common as memberPhoneRules } from 'services/validation/rules/memberPhone.rules';
import produce from 'immer';
import { buildForm } from 'components/BusinessLogic/MemberPhoneForm/buildForm';
import { buildMemberPhoneSelector } from 'store/selectors/memberPhones.selector';
import ErrorMessage from 'components/UI/ErrorMessage';

function MemberPhoneForm({
    memberPhone, onCancel, onSuccess, storeMemberPhone,
})
{
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [phoneMemberForm, setPhoneMemberForm] = useState(
        {
            ...buildForm(memberPhoneRules),
            data: {
                id: memberPhone?.id,
                country_code: memberPhone?.country_code ?? '',
                phone: `${memberPhone?.area_code ?? ''}${memberPhone?.phone ?? ''}`,
            },
        },
    );

    const updateDataForm = (name, value) =>
    {
        const form = produce(phoneMemberForm, (draft) =>
        {
            draft.data[name] = value;
        });

        setPhoneMemberForm({ ...form });
    };

    const cancelForm = () =>
    {
        if (onCancel)
        {
            onCancel();
        }
    };

    const handleForm = async () =>
    {
        setIsLoading(true);
        setErrorMessage('');

        storeMemberPhone({ ...phoneMemberForm.data }).then((result) =>
        {
            if (onSuccess)
            {
                onSuccess({ ...memberPhone, ...phoneMemberForm.data, ...result });
            }
        }).catch((e) =>
        {
            setErrorMessage(e.message ?? e);
        }).finally(() =>
        {
            setIsLoading(false);
        });
    };

    return (
        <FormComponent
            className="tw-gap-2"
            source={phoneMemberForm}
            onFormChange={
                () =>
                {}
            }
        >
            <ErrorMessage errorMessage={errorMessage} />
            <Row className="tw-py-2">
                <h2 className="tw-text-xl tw-font-bold dark:tw-text-neutral-300">{memberPhone ? 'Edit' : 'Add' } Phone</h2>
            </Row>
            <Row className="tw-py-1 tw-gap-1">
                <EditableTextInput
                    containerClassName="tw-py-2"
                    labelText="Country Code"
                    text={phoneMemberForm.data.country_code}
                    editing
                    inputProps={{
                        path: 'country_code',
                        disabled: isLoading,
                        error: phoneMemberForm.errorsBag.errors.country_code,
                        value: phoneMemberForm.data.country_code,
                        placeholder: 'Eg: 1',
                        onChange: (value) => updateDataForm('country_code', value),
                    }}
                />
                <EditableTextInput
                    containerClassName="tw-py-2"
                    labelText="Phone"
                    text={phoneMemberForm.data.phone}
                    editing
                    inputProps={{
                        path: 'phone',
                        disabled: isLoading,
                        error: phoneMemberForm.errorsBag.errors.phone,
                        value: phoneMemberForm.data.phone,
                        placeholder: 'Eg: 2223334455',
                        onChange: (value) => updateDataForm('phone', value),
                    }}
                />
            </Row>

            <div className="tw-ml-8 tw-text-right">
                <Button onClick={cancelForm} customBg="tw-bg-white tw-text-black">Cancel</Button>
                <Button onClick={handleForm} type="primary" margin="tw-ml-2">Save <LoadingSpinner loading={isLoading} className="tw-mr-1" /></Button>
            </div>

        </FormComponent>
    );
}

MemberPhoneForm.propTypes = {
    memberPhone: PropTypes.shape({
        id: PropTypes.number,
        phone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        country_code: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        area_code: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    storeMemberPhone: PropTypes.func,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
};
const mapStateToProps = () =>
{
    const memberPhoneSelector = buildMemberPhoneSelector();

    return (state, props) =>
    {
        const { memberPhoneId } = props;
        return { memberPhone: memberPhoneSelector(state, memberPhoneId) };
    };
};

const mapDispatchToProps = (dispatch, props) =>
{
    const { memberId, memberPhoneId } = props;
    return {

        storeMemberPhone(data)
        {
            if (memberPhoneId)
            {
                return dispatch(updateMemberPhone(memberId, memberPhoneId, data));
            }
            return dispatch(saveMemberPhone(memberId, data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MemberPhoneForm);
